/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');

const Q_at_board_edge = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  const slam = BattleCalc.getEquippedAbility(actor, 'slam');

  node.branches[node.NO] = slam
    ? new UseAbility(actor, 'slam')
    : new TreeNode(null, null);

  node.branches[node.YES] = new TreeNode(null, null);

  node.yesNoEvalFunction = function (target) {
    return BattleCalc.targetIsAtBoardEdge(actor, target, battleState);
  };

  return node;
};
module.exports = Q_at_board_edge;
